<template>
    <div class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("prepare-get-survey.get-survey") }}
                </p>
                <button class="delete" @click="close"></button>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">{{
                        $t("prepare-get-survey.title")
                    }}</label>
                    <div class="control">
                        <input v-model="title" type="text" class="input" />
                    </div>
                    <p v-if="haveError" class="help is-danger">{{ error }}</p>
                </div>
                <UserSelect v-model="selectedUser" />
            </section>
            <footer class="modal-card-foot is-justify-content-flex-end">
                <button class="button" @click="send">
                    <Icon
                        name="fa-paper-plane"
                        helperClass="has-text-primary"
                    />
                    <span>{{ $t("prepare-get-survey.send") }}</span>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import UserSelect from "../UserSelect.vue";

export default {
    name: "prepare-get-survey",
    components: {
        UserSelect,
    },
    data() {
        return {
            title: "",
            selectedUser: null,
            error: "",
        };
    },
    computed: {
        isEmptyTitle() {
            return this.title === "" || this.title === null;
        },
        isUserSelected() {
            return this.selectedUser !== null;
        },
        haveError() {
            return this.error !== "";
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        send() {
            if (this.isEmptyTitle) {
                this.error = this.$t("prepare-get-survey.empty-title");
                return;
            }

            if (!this.isUserSelected) {
                this.error = this.$t("prepare-get-survey.user-not-selected");
                return;
            }
            this.error = null;

            this.$emit("sendAction", {
                type: "get-survey",
                state: 0,
                user: this.selectedUser,
                title: this.title,
            });
        },
    },
};
</script>